import React from 'react'
import styled from "styled-components";
import { NavLink } from "react-router-dom";

import { useToastContext } from "@/contexts/ToastContext";
import { useNavigate } from "react-router-dom";
import { useAccount } from 'wagmi'
export default function Nav() {

  const navigate = useNavigate();
  const { isConnected } = useAccount();

  const toLink = (e, path)=>{
    e.preventDefault();
    if(!isConnected){
      return showToast({
        dir:'top',
        type:'success',
        text:'Please Login first!'
      })
    }else{
      navigate(path);
    }
  }

  const { showToast } = useToastContext();

  return (
    <NavWrapper>
      <div className='menus'>
        <NavLink activeclassname="active" exact="true" to="/mint" className='menu-item'>Jungle Squad</NavLink>
        <NavLink activeclassname="active" className='menu-item' to="/my"
                 onClick={(e) => toLink(e, '/my') }
        >My Squad</NavLink>

        <NavLink activeclassname="active" className='menu-item' to="/warrior"
                 onClick={(e) => toLink(e, '/warrior') }
                 >My Warriors</NavLink>
        <NavLink activeclassname="active" className='menu-item' to="/synth"
                 onClick={(e) => toLink(e, '/synth') }
        >Synth Warriors</NavLink>
      </div>
    </NavWrapper>
    //
  )
}

const NavWrapper = styled.div`
  padding-right:26px;  
  .menus{
    display: flex;
    flex-direction: column;
    align-items: center;
    .menu-item{
      box-sizing: border-box;
      cursor: pointer;
      width: 139px;
      height: 44px;
      line-height: 44px;
      border-radius: 8px;
      text-align: center;
      font-weight: 400;
      font-size: 16px;
      color: #32DE86;
      border: 1px solid #32DE86;
      &.active{
        font-weight: 700;
        color: #000;
        width: 150px;
        height: 48px;
        line-height: 48px;
        background: #32DE86;
      }
      &.disabled{
        color: #4D4D4D;
        border: 1px solid #4D4D4D;        
      }
      & + .menu-item{
        margin-top: 36px;
      }
    }
  }
`
